var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgChevronLeftTransparent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(90 23.5 0.5)",
    stroke: "#5D5CF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0689 12L14.7501 15.6811C15.0849 16.016 15.0849 16.559 14.7501 16.8938C14.4152 17.2287 13.8723 17.2287 13.5374 16.8938L9.24988 12.6063C8.915 12.2715 8.915 11.7285 9.24988 11.3936L13.5374 7.10614C13.8723 6.77126 14.4152 6.77126 14.7501 7.10614C15.0849 7.44101 15.0849 7.98395 14.7501 8.31882L11.0689 12Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronLeftTransparent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron-left-transparent.16e28222.svg";
export { ForwardRef as ReactComponent };